<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="timeline-box">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in reviewLogList"
            :key="item.id"
            :color="
              item.auditType == -1
                ? 'red'
                : index + 1 == reviewLogList.length
                  ? '#1890ff'
                  : '#0bbd87'
            "
          >
            <el-card>
              <p>
                <b>
                  {{
                    item.auditType != null
                      ? statusList.find((i) => i.value == item.auditType).label
                      : ""
                  }}
                </b>
              </p>
              <p
                v-if="
                  item.auditType != 1 &&
                  item.auditType != -1 &&
                  item.auditType != -2 &&
                  item.auditType != 4
                "
              >
                评审专家：{{ item.auditorName }}
              </p>
              <p v-if="item.auditType == -2 || item.auditType == -1">
                操作人员：{{ item.auditorName }}
              </p>
              <p v-if="item.auditType == -1">退回原因：{{ item.backReason }}</p>
              <p v-if="item.auditType == -2">取消原因：{{ item.backReason }}</p>
              <p>时间：{{ item.auditTime }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getReviewLogListApi } from "@/api/home";

export default {
  props: ["details"],
  data() {
    return {
      dialogVisible: false,
      reviewLogList: [],
      statusList: [
        {
          label: "申报成功",
          value: 1,
        },
        {
          label: "初审",
          value: 2,
        },
        {
          label: "终审",
          value: 3,
        },
        {
          label: "企业提交补充资料",
          value: 4,
        },
        {
          label: "初审完成",
          value: 5,
        },
        {
          label: "终审完成",
          value: 6,
        },
        {
          label: "退回",
          value: -1,
        },
        {
          label: "取消资格",
          value: -2,
        },
      ],
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        this.dialogVisible = newValue.dialogVisible;
        this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
        if (newValue.dialogVisible) {
          this.getById();
        }
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleSubmit() {
      this.$emit("handleClose");
    },
    getById() {
      // 评审进度
      getReviewLogListApi({
        declareId: this.details.data.id,
        token: this.xh_userInfo.token,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.reviewLogList = res.result || [];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .timeline-box {
  }
}
</style>
